import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// Create a new coupons
export const createCoupon = createAsyncThunk(
  "coupons/createCoupon",
  async ({ token, payload }) => {
    const response = await api.post("/coupons", { ...payload }, { token });
    return response.data;
  }
);

// Get all coupons
export const getAllCoupons = createAsyncThunk(
  "coupons/getAllCoupons",
  async ({ token, ...queryParams }) => {
    const response = await api.get("/coupons", {
      token,
      params: queryParams,
    });
    return response.data;
  }
);

// Update an existing coupon
export const updateCoupon = createAsyncThunk(
  "coupons/updateCoupon",
  async ({ token, id, payload }) => {
    const response = await api.patch(
      `/coupons/${id}`,
      { ...payload },
      { token }
    );
    return response.data;
  }
);

// Delete an coupon by code
export const deleteCoupon = createAsyncThunk(
  "coupons/deleteCoupon",
  async ({ token, code }) => {
    const response = await api.delete(`/coupons/${code}`, { token });
    return response.data;
  }
);
